module.exports = __webpack_public_path__ + "img/webase1.e4d6142d.png";